<div class="container-fluid p-3">
  <div class="page-header mb-4">
    <div class="d-flex justify-content-between align-items-center">
      <div>
        <h4 class="mb-1">
          {{ stepDetails.name }}
        </h4>
        <h5 class="text-primary">[{{ payload?.proposal_name }}]</h5>

      </div>
      <div class="action-buttons">
        
  
        <ng-container *ngIf="stepDetails?.can_edit">
          <button class="btn btn-primary me-2"  (click)="routeConfig.emit({isRouteConfig: true})">
            <i class="pi pi-save me-1"></i> Save/Forward/Route Config
          </button>
        </ng-container>
  
        
      </div>
    </div>
  </div>


  <hr class="my-3" />

  <div *ngIf="needData" class="mb-4">
    <div  class="rounded-lg overflow-hidden border border-blue-200 shadow bg-gradient-to-tr from-blue-50 to-blue-100">
      <button  type="button"    (click)="expandedSections['needGenFrom'] = !expandedSections['needGenFrom']"
        class="w-full flex items-center justify-between px-5 py-3 transition-colors duration-200 cursor-pointer focus:outline-none focus:ring-2 focus:ring-blue-400 group"
        [attr.aria-expanded]="expandedSections['needGenFrom']"
        [attr.aria-controls]="'needGenFrom-panel'"
      >
        <span class="flex items-center gap-3">
          <span class="text-base font-semibold text-blue-800">Need Generation From</span>
          
        </span>
        <span  class="transition-all transform duration-200 bg-blue-100 rounded-full p-1.5 group-hover:bg-blue-200"     >
          <i class="pi"  [ngClass]="{
              'pi-chevron-down': expandedSections['needGenFrom'],
              'pi-chevron-right': !expandedSections['needGenFrom']
            }"
          ></i>
        </span>
      </button>
      <div *ngIf="expandedSections['needGenFrom']" id="needGenFrom-panel"
        class="bg-white border-t border-blue-100 px-3 py-2 animate-fadeIn"
        style="animation: fadeIn .3s;">
        <app-needfrom [data]="needData"></app-needfrom>
      </div>
    </div>
  </div>

  <!-- Uploaded Document Section -->
  <div>
    <ng-container *ngIf="stepDetails.code === 'R-FSOTR'; else elseBlock">
      <app-upload-document
        [title]="'Uploaded Document'"
        [isEditable]="stepDetails?.can_edit"
        [proposal_step]="stepDetails?.id-2"
      ></app-upload-document>
    </ng-container>
    <ng-template #elseBlock>
      <app-upload-document
        [title]="'Uploaded Document'"
        [isEditable]="stepDetails?.can_edit"
        [proposal_step]="stepDetails?.id-2"
      ></app-upload-document>
    </ng-template>
  </div>
  <form class="proposal-form-container">
    <div class="form-container">
      
      <div class="row mt-4">
        <div class="col-4 bg-primary text-white d-flex align-items-center">
          <b class="fw-semibold mb-0 text-white">Remarks </b>
        </div>
        <div class="col-8">
          <textarea
              id="remarks"
              name="remarks"
              [(ngModel)]="remark"
              class="form-control"
              rows="4"
              placeholder="Enter any remarks..."
            ></textarea>
        </div>
      </div>
     
      <!-- button Section -->
       
    </div>
  </form>
 
</div>